import script from "./BookList.vue?vue&type=script&setup=true&lang=js"
export * from "./BookList.vue?vue&type=script&setup=true&lang=js"

import "./BookList.vue?vue&type=style&index=0&id=827f0cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827f0cda"]])

export default __exports__